module.exports = __webpack_public_path__ + "static/media/Ecran-1-Borne.1cfb816c.jpg";